module.exports = __webpack_public_path__ + "static/z-7g-wide-72c6db6b6ba1cad5aa0712ec2a623d4d.jpg";